import { useEffect, useState } from "react";
import { Col, Container, FloatingLabel, Form, Row } from "react-bootstrap";
import Draggable from 'react-draggable';
import { useAddDriverToOpenOrderMutation, useGetDivisionListQuery, useLazyGetAllActiveOpenOrdersQuery, useLazyGetAllSelectedDriverDetailsQuery, useLazyGetAssignedOrdersToDriverQuery, useLazyGetDriverNumberListQuery, useLazyGetDriversFromBoardQuery } from "../../../features/Dispatch/DispatchSlice";
import Wrapper from "../../Wrapper";
import DriverList from "../TripDispatch/DriverList";
import DispatchedTo from "./DispatchedTo";
import DriverDetails from "./DriverDetails";
import NowLater from "./NowLater";
import OnBoardVehicle from "./OnboardVehicle";
import OpenOrder from "./OpenOrder";
import OrderDetails from "./OrderDetails/OrderDetails";
import OrderDetailsMin from "./OrderDetails/OrderDetailsMin";
import OrdersTable from "./OrdersTable";
import Routing from "./Routing";

const LocalDispatch = () => {
    const [open, setOpen] = useState(false);
    const { data: divisionList } = useGetDivisionListQuery()
    const [divisionId, setDivisionId] = useState()
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [fetchDrivers, result] = useLazyGetDriversFromBoardQuery();
    const [getDriverList, driverListResult] = useLazyGetDriverNumberListQuery()
    const [getAssignedOrdersToDriver] = useLazyGetAssignedOrdersToDriverQuery();
    const [addDriverToOpenOrder] = useAddDriverToOpenOrderMutation();
    const [fetchRegionalOrders, ordersResult] = useLazyGetAllActiveOpenOrdersQuery()
    const [selectedDriverOrders, setSelectedDriverOrders] = useState([]);
    const [onBoardOrders, setOnBoardOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [getSelectedDriverDetails] = useLazyGetAllSelectedDriverDetailsQuery();
    const [nowLater, setNowLater] = useState('now');
    const [ordersTable, setOrdersTable] = useState([]);
    const [assignedOrders, setAssignedOrders] = useState([]);
    const [showAssignedOrders, setShowAssignedOrders] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    useEffect(() => {
        getDriverList();
    }, []);

    const assignDriverToOrder = async (type, ID, orderNumber) => {
        if (!selectedDriver) {
            return;
        }
        let dropOffDriverNumber = null;
        if (type === 'DDrive') {
            dropOffDriverNumber = selectedDriver?.driverNumber;
        }
        await addDriverToOpenOrder({ divisionId: divisionId, dropOffDriverNumber: dropOffDriverNumber, orderId: ID, orderNumber: orderNumber, pickUpDriverNumber: selectedDriver?.driverNumber });
        const result = await getSelectedDriverDetails({ divisionId: divisionId, driverNumber: selectedDriver?.driverNumber });
        setSelectedDriver(result?.data?.data);
        setSelectedDriverOrders(result?.data?.data?.dispatchedOrderDetails);
        const orders = await getAssignedOrdersToDriver({ divisionId: divisionId, driverNumber: selectedDriver?.driverNumber });
        setAssignedOrders(orders.data.data);
    }

    return (
        <Wrapper>
            <Container fluid>
                <Row>
                    <Col md={7} lg={5} className="mb-2 dispatch-main"><h3>Same Day Dispatch </h3></Col>
                    <Col md={7} lg={2}>
                        <Form.Group controlId="drivernumber">
                            <FloatingLabel controlId="floatingSelectGrid" label="Select division">
                                <Form.Select aria-label="Floating label select example" name="divisionId"
                                    onChange={(e) => {
                                        setDivisionId(e.target.value);
                                        getDriverList(e.target.value)
                                        setSelectedOrder(null)
                                        setSelectedDriver(null)
                                    }
                                    }>
                                    <option value="">Select</option>
                                    {divisionList?.data?.map((data, index) => (
                                        <option key={index} value={data?.divisionId} >{data?.divisionName}</option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        </Form.Group>
                    </Col>
                    <Col md={5} lg={2} className="mb-2 mt-2 mt-md-0"><NowLater nowLater={nowLater} setNowLater={setNowLater} style={{ height: "48px" }} /></Col>
                    <Col md={5} lg={3} className="mb-2">
                        <Routing
                            selectedDriver={selectedDriver}
                            fetchDrivers={fetchDrivers}
                            divisionId={divisionId}
                            getDriverList={getDriverList}
                            driverListResult={driverListResult}
                            assignedOrders={assignedOrders}
                        />
                    </Col>
                    {isMobile ?
                        <div>
                            <DriverDetails selectedDriver={selectedDriver} setSelectedDriver={setSelectedDriver} />
                            <DriverList
                                fetchDrivers={fetchDrivers}
                                result={result}
                                selectedDriver={selectedDriver}
                                setSelectedDriver={setSelectedDriver}
                                divisionId={divisionId}
                                getAssignedOrdersToDriver={getAssignedOrdersToDriver}
                                setSelectedDriverOrders={setSelectedDriverOrders}
                                setOnBoardOrders={setOnBoardOrders}
                                getDriverList={getDriverList}
                                setAssignedOrders={setAssignedOrders}
                            />
                        </div>
                        : null}
                </Row>
                <Row className="contain-order-flex mb-2">
                    <Col lg={8}>
                        <Draggable disabled={isMobile}>
                            <div className="mb-2" >
                                {selectedOrder && <OrderDetailsMin selectedOrder={selectedOrder} setSelectedOrder={setSelectedOrder} divisionId={divisionId} />}
                                {open && <OrderDetails setSelectedOrder={setSelectedOrder} setOpen={setOpen} />}
                            </div>
                        </Draggable>
                        {selectedOrder == null ? < Col sm={12} >
                            <Draggable disabled={isMobile}>
                                <div className="mb-2">
                                    <OpenOrder
                                        assignDriverToOrder={assignDriverToOrder}
                                        setSelectedOrder={setSelectedOrder}
                                        setOpen={setOpen}
                                        divisionId={divisionId}
                                        nowLater={nowLater}
                                        fetchRegionalOrders={fetchRegionalOrders}
                                        ordersResult={ordersResult} />
                                </div>
                            </Draggable>
                        </Col> : null}
                    </Col>
                    {
                        !isMobile ? <Col lg={4}>
                            <Draggable className="draggable-width" >
                                <div>
                                    <DriverDetails selectedDriver={selectedDriver} setSelectedDriver={setSelectedDriver} />
                                    <DriverList
                                        fetchDrivers={fetchDrivers}
                                        result={result}
                                        selectedDriver={selectedDriver}
                                        setSelectedDriver={setSelectedDriver}
                                        divisionId={divisionId}
                                        getAssignedOrdersToDriver={getAssignedOrdersToDriver}
                                        setSelectedDriverOrders={setSelectedDriverOrders}
                                        setOnBoardOrders={setOnBoardOrders}
                                        getDriverList={getDriverList}
                                        setAssignedOrders={setAssignedOrders}
                                    />
                                </div>
                            </Draggable>
                        </Col> : null
                    }
                </Row>
                <Row>
                    {showAssignedOrders &&
                        <Draggable>
                            <div className="mb-2" >
                                <OrdersTable
                                    setOnBoardOrders={setOnBoardOrders}
                                    setOrdersTable={setOrdersTable}
                                    selectedDriver={selectedDriver}
                                    nowLater={nowLater}
                                    assignedOrders={assignedOrders}
                                    setSelectedOrder={setSelectedOrder}
                                    divisionId={divisionId}
                                    ordersTable={ordersTable}
                                    setShowAssignedOrders={setShowAssignedOrders}
                                    setSelectedDriverOrders={setSelectedDriverOrders}
                                    getSelectedDriverDetails={getSelectedDriverDetails}
                                    setAssignedOrders={setAssignedOrders}
                                    setSelectedDriver={setSelectedDriver}
                                />
                            </div>
                        </Draggable>
                    }
                </Row>
                {selectedOrder ? <Col sm={12} >
                    <Draggable disabled={isMobile}>
                        <div className="mb-2">
                            <OpenOrder
                                assignDriverToOrder={assignDriverToOrder}
                                setSelectedOrder={setSelectedOrder}
                                setOpen={setOpen}
                                divisionId={divisionId}
                                nowLater={nowLater}
                                fetchRegionalOrders={fetchRegionalOrders}
                                ordersResult={ordersResult} />
                        </div>
                    </Draggable>
                </Col> : null}
                <Row>
                    <Col sm={12} lg={6}>
                        <Draggable>
                            <div>
                                <DispatchedTo
                                    disableDragging={isMobile}
                                    setSelectedDriverOrders={setSelectedDriverOrders}
                                    selectedDriver={selectedDriver}
                                    selectedDriverOrders={selectedDriverOrders}
                                    setSelectedOrder={setSelectedOrder}
                                    setOpen={setOpen}
                                    divisionId={divisionId}
                                    getSelectedDriverDetails={getSelectedDriverDetails}
                                    setOnBoardOrders={setOnBoardOrders}
                                    fetchDrivers={fetchDrivers}
                                    fetchRegionalOrders={fetchRegionalOrders}
                                    setSelectedDriver={setSelectedDriver}
                                    setShowAssignedOrders={setShowAssignedOrders}
                                    setOrdersTable={setOrdersTable}
                                    assignedOrders={assignedOrders}
                                    setAssignedOrders={setAssignedOrders}
                                />
                            </div>
                        </Draggable>
                    </Col>
                    <Col sm={12} lg={6}>
                        <Draggable>
                            <div>
                                <OnBoardVehicle
                                    onBoardOrders={onBoardOrders}
                                    setSelectedOrder={setSelectedOrder}
                                    setOpen={setOpen}
                                    divisionId={divisionId}
                                    selectedDriver={selectedDriver}
                                    getSelectedDriverDetails={getSelectedDriverDetails}
                                    fetchDrivers={fetchDrivers}
                                    setOnBoardOrders={setOnBoardOrders}
                                    fetchRegionalOrders={fetchRegionalOrders}
                                    setSelectedDriver={setSelectedDriver}
                                    setShowAssignedOrders={setShowAssignedOrders}
                                    setOrdersTable={setOrdersTable}
                                    assignedOrders={assignedOrders}
                                    setAssignedOrders={setAssignedOrders}
                                />
                            </div>
                        </Draggable>
                    </Col>
                </Row>
            </Container >
        </Wrapper >
    )
}
export default LocalDispatch;